import { c as _c } from "react/compiler-runtime";
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import useUser from 'shared/hooks/use-user';
export const growthbookClient = new GrowthBook({
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.NODE_ENV === 'development'
});
interface GrowthbookClientProviderProps extends PropsWithChildren {
  currentPath: string;
}
export function GrowthbookClientProvider(t0) {
  const $ = _c(5);
  const {
    children,
    currentPath
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== currentPath) {
    t2 = [currentPath];
    $[1] = currentPath;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <GrowthBookProvider growthbook={growthbookClient}>{children}</GrowthBookProvider>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2() {
  growthbookClient.setURL(window.location.href);
}
function _temp() {
  growthbookClient.init({
    skipCache: true,
    streaming: true
  });
}
export function useSyncGrowthbookUserAttributes() {
  const $ = _c(3);
  const {
    user
  } = useUser();
  let t0;
  let t1;
  if ($[0] !== user) {
    t0 = () => {
      if (!user) {
        return;
      }
      growthbookClient.setAttributes({
        id: user.id,
        roles: user.roles,
        userPlanId: user.userPlanId,
        country: user.country
      });
    };
    t1 = [user];
    $[0] = user;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}